<template>
  <section :id="data?.anchor_id ? data.anchor_id : null" class="similarAccommodations defaultSectionPaddings">
    <div class="container">
      <h2 v-text="data.title" />

      <SimilarAccommodationsSlider :locations="locations" :flickityOptions="flickityOptions" />
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });

  const { page } = usePage();
  const { accommodationsData } = useSetup();
  const dataLayerList = useState('dataLayerList');

  const flickityOptions = {
    pageDots: false,
    contain: true,
    cellAlign: 'left',
  };

  const locations = computed(() => {
    let results = [];
    for (let item of props.data.items) {
      if (accommodationsData.value[item.accommodation]) results.push(accommodationsData.value[item.accommodation])
    }
    return results;
  })

  let allItems = JSON.parse(JSON.stringify(locations.value));
  let ecommerceItems = [];
  ecommerceItems = allItems.map((accommodation, index) => {
    return {
      'item_id': accommodation.id,
      'item_name': accommodation.name,
      'item_category': accommodation.kind === 'CAMP' ? 'Campsites' : 'Hotels and resorts',
      'item_category2': accommodation.place?.name,
      'item_brand': accommodation.brand?.name,
      'item_list_name': props.data.title,
      'item_list_id': 'Accommodation',
      'index': index + 1,
    }
  });
  
  onMounted(() => {
    dataLayerList.value = ecommerceItems;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      'event': 'view_item_list',
      'ecommerce': {
        'items': ecommerceItems,
      },
    });
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_similarAccommodations.scss');
</style>